import Full from './Full';
import Dashboard from './Dashboard/Dashboard'

export { Full, Dashboard };


// WEBPACK FOOTER //
// ./src/containers/index.js